import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Obtener marcas con sus modelos
const getMakers = async () => {
  try {
    const response = await api.get('/api/makers');
    return response.data;
  } catch (error) {
    console.error('Error al obtener marcas:', error);
    throw error;
  }
};

// Ejemplo de GET (mantener para compatibilidad)
const getItems = async () => {
  try {
    const response = await api.get('/ObtenerMarcas');
    return response.data;
  } catch (error) {
    console.error('Error al obtener items:', error);
    throw error;
  }
};



export default {
  getItems,
  getMakers
};